import { gql } from "@apollo/client";

const GET_VENDOR_LOCATION = gql`
  query {
    getVendorLocation {
      data {
        countryCode
        countryName
      }
      error
      status
    }
  }
`;

export default GET_VENDOR_LOCATION;
